import { useState } from 'react';
import styles from './tabs.module.scss';
import { Tab } from '~/components/Tab/Tab';
import classNames from 'classnames';
import { GradientName } from '~/interfaces/GradientName';

export type TabInfo = {
  /**
   * Tab label
   */
  label: string;
  /**
   * Tab key
   */
  key: string;
  gradient?: GradientName;
  disabled?: boolean;
};

interface TabsProps {
  tabs: TabInfo[];
  initialTabKey?: string;
  darkMode?: boolean;
  fullWidth?: boolean;
  noGap?: boolean;
  withBottomBorder?: boolean;
  onClick: (key: string) => void;
  isDebug?: boolean;
  containerClassName?: string;
}

const Tabs = ({
  onClick,
  tabs,
  darkMode,
  fullWidth,
  noGap,
  withBottomBorder,
  isDebug = false,
  initialTabKey,
  containerClassName = '',
}: TabsProps) => {
  const [selected, setSelected] = useState(initialTabKey || tabs[0].key);
  function onTabClick(key: string) {
    isDebug && console.log(key);
    setSelected(key);
    onClick && onClick(key);
  }
  if (tabs?.length < 2) {
    return null;
  }

  return (
    <div
      className={classNames(
        styles.tabsRoot,
        { [styles['full-width']]: fullWidth },
        { [styles['no-gap']]: noGap },
        { [styles['bottom-border']]: withBottomBorder },
        containerClassName
      )}
    >
      {tabs.map(tab => (
        <Tab
          onClick={() => onTabClick(tab.key)}
          active={selected === tab.key}
          label={tab.label}
          key={tab.key}
          darkMode={darkMode}
          gradient={tab.gradient ?? 'multi1'}
          disabled={tab.disabled}
        />
      ))}
    </div>
  );
};
export default Tabs;
